<template>
  <div class="scroll" ref="scrollBar" v-bar="{
    preventParentScroll: false,
    scrollThrottle: 30,
    draggerThrottle: 30,
    observerThrottle: 30,
    resizeRefresh: true
  }">
  <!-- @wheel="scrolling" -->
    <ul class="flow" ref="scrollChild" >
      <li v-for="(item, index) of messages" :key="index" :id="item.id" class="flow-item" >

      <!-- :class="item.isMy ? 'user' : 'bot'" -->

        <!-- <v-avatar v-if="imgSrc(item)" tile class="rounded-circle" size="48">
          <img width="48" height="48" :src="imgSrc(item)" alt="bot">
        </v-avatar> -->

        <!-- <div style="color: black">{{ item }}</div> -->

        <v-lazy
          class="lazy"
          :options="{
            threshold: .5
          }"
          min-height="50"
          transition="fade-transition"
        >
          <!-- <div>   -->
          <!-- <v-avatar v-if="imgSrc(item)" tile class="rounded-circle" size="48">
          <img width="48" height="48" :src="imgSrc(item)" alt="bot">
        </v-avatar> -->

          <Message
            :value="item"
            :theme="theme.content"
            :is-user-icon="isUserIcon"
            :is-last-message="index === messages.length - 1"
            :is-allow-html="isAllowHtml"
            :message-owner="item.isMy ? 'user' : 'bot'"
            :styles="item.isMy ? userStyles : botStyles"
            :style="{ color: item.isMy ? userStyles.bubble.fontColor : botStyles.bubble.fontColor }"
            @input="onInput"
            v-in-viewport="markAsRead(item)"
          />
          <!-- </div> -->
        </v-lazy>
      </li>
    </ul>

    <v-btn class="icon-down" v-show="showArrowDown" @click="scrollBottom" icon large :style="{ backgroundColor: botStyles.bgColor }">
      <v-icon :style="{ color: userStyles.defaultFontColor }">
        {{ mdiChevronDown }}
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { mdiChevronDown } from '@mdi/js';

export default {
  name: 'ChatFlow',
  data() {
    return {
      interval: null,
      willScroll: true,
      showArrowDown: false,
      mdiChevronDown,
      messageOwner: "",
      scrollbol: true,
    };
  },
  mounted() {
      // const splittedParams = window.location.search.split('&')
      // const focusMsgId = splittedParams.find(param => param.includes('focusMsgId'))?.split('=')[1]
      // window.clearInterval(this.interval);
      // let element = document.getElementById(`91679006-516d-416f-b6a2-0fee88ab593f`);
      // element?.classList.add('focused-message');
      // element.scrollIntoView({ behavior: 'smooth' });
    
        // if (this.$refs.scrollChild) {
        //   this.$refs.scrollChild.scrollTop = this.$refs?.scrollChild?.scrollHeight;
        // }
    const handler = () => {
      window.clearInterval(this.interval);
      const { barTop, barHeight, el2} = this.$refs?.scrollBar?._vuebarState;
      this.willScroll = barTop + barHeight + 1 >= el2?.clientHeight;
      this.showArrowDown = !this.willScroll;
    };

    this.$refs?.scrollChild.addEventListener('wheel', handler);
    this.$refs?.scrollChild.addEventListener('touchmove', handler);

    document.querySelector('input.field').addEventListener('blur', () => {
      document.body.scrollTop = 0;
    });
  },
  computed: {
    ...mapGetters({
      messages: 'chatFlow/messages',
      theme: 'theme/theme',
      isAllowHtml: 'theme/isAllowHtml',
      isUserIcon: 'theme/isUserIcon'
    }),
    userStyles() {
      return {
        bgColor: this.$store.getters['theme/theme']?.common?.bgColor,
        defaultFontColor: this.$store.getters['theme/theme'].common?.fontColor,
        color: this.$store.getters['theme/btnBgColor'],
        bubble: {
          color: this.theme?.content?.userBubbleColor,
          fontColor: this.theme?.content?.userFontColor,
        }
      }
    },
    botStyles() {
      return {
        bgColor: this.$store.getters['theme/theme']?.common?.bgColor,
        defaultFontColor: this.$store.getters['theme/theme'].common?.fontColor,
        color: this.$store.getters['theme/btnBgColor'],
        bubble: {
          color: this.theme?.content?.botBubbleColor,
          fontColor: this.theme?.content?.botFontColor,
        }
      }
    }
  },
  watch: {
    messages() {
      // if (this.willScroll) {
        // console.log(this.messages[this.messages.length-1].options)
        // console.log(this.scrollBottom())
        this.scrollBottom();

        if(this.scrollbol){
          setTimeout( () => {
            this.scrollbol = false
            window.clearInterval(this.interval);
            const splittedParams = window.location.search.split('&')
            const focusMsgId = splittedParams.find(param => param.includes('focusMsgId'))?.split('=')[1]
            let element = document.getElementById(focusMsgId);
            element?.classList.add('focused-message');
            element?.scrollIntoView({ behavior: 'smooth' });

          }, 2000)
        }
      // }
    }
  },
  methods: {
    // scrolling(e) {
    //   if (e.deltaY < 0) {
    //     this.willScroll = false;
    //     this.showArrowDown = true;
    //     console.log("--->", this.showArrowDown);
    //   }
    // },
    scrollBottom() {
      this.willScroll = true;
      this.showArrowDown = false;
      window.clearInterval(this.interval);
      this.interval = window.setInterval(() => {
        if (this.$refs.scrollChild) {
          this.$refs.scrollChild.scrollTop = this.$refs?.scrollChild?.scrollHeight;
        }
      }, 100);
    },
    imgSrc(item) {
      if (item.isMy && !this.isUserIcon) {
        return null;
      }

      return item.isMy ? this.theme?.content?.user : this.theme?.content?.bot;
    },
    onInput(value) {
  
      if (value.type === 'webview') {
        this.$root.$emit('show:webview', value);
      } else {
        this.$store.dispatch('chatFlow/send', value);
      }
    },
    markAsRead(item) {
      if (!item.isMy) {
        this.$store.dispatch('chatFlow/markAsRead', item.id);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.scroll {
  width: 100% !important;
  height: 100% !important;
  position: fixed !important;
  box-sizing: border-box !important;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  overflow: hidden;
}

.flow {
  margin: 0;
  // padding: .5em !important;
  padding: 2.0em 1.4em !important;
  // padding-right: .5em !important;
  padding-bottom: 1em;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  box-sizing: border-box !important;

  .flow-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 1em;

    .lazy {
      width: 100%;
      display: flex;
      flex-flow: inherit;
    }

    &.my, &.his {
      .content {
        display: inline-block;
        width: auto;
        // max-width: 85%;
        max-width: 300px;
        overflow: hidden;
      }

      .v-avatar {
        display: flex;
        align-content: center;
        justify-content: center;
        border: 1px solid #fff;

        @media screen and (max-width: 768px) {
          width: 35px !important;
          height: 35px !important;
          min-width: 35px !important;
        }
      }
    }

    &.my {
      flex-flow: row-reverse;

      // .content {
      //   border-radius: $base-border-radius $base-border-radius 0 $base-border-radius;
      // }

      .v-avatar {
        margin-left: .5rem;
      }
    }

    &.his {
      // .content {
      //   padding: 0;
      //   border-radius: 0 $base-border-radius $base-border-radius $base-border-radius;
      // }

      .v-avatar {
        margin-right: .5rem;
      }
    }
  }
}

.icon-down {
  position: fixed;
  z-index: 10;
  right: 1rem;
  bottom: 6rem;
  height: 45px !important;
  width: 45px !important;
}

@keyframes focus {
  0% {
    opacity: 1;
  }

  25% {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }

  75% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.focused-message {
  animation-name: focus;
  animation-duration: 2s;
  animation-delay: 1.5s;
  scroll-margin: 60px;

}
</style>
